<template>
  <span class="upload-tips">（自己访问不产生轨迹）</span>
</template>